import React, { useState } from "react";
import hide from "../../assets/images/createPassword/hide.svg";
import show from "../../assets/images/createPassword/show.svg";
import darkShow from "../../assets/images/createPassword/darkShow.svg";
import darkHide from "../../assets/images/createPassword/darkHide.svg";
import useTheme from "hooks/observer";

import "./inputPassword.scss";
import useScreenMobile from "hooks/useScreen";

const InputPassword = ({
  onChange = () => {},
  value = "",
  error,
  inputWidth = "370px",
  errorMessage = ""
}) => {
  const isMobile = useScreenMobile({ size: 992 });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handlePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const theme = useTheme();
  const hideImage = theme === "light" ? hide : darkShow;
  const showImage = theme === "light" ? show : darkHide;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div
      className="passwordManagerPasswordInput"
      // style={{
      //   width: isMobile ? "221px" : inputWidth
      // }}
      style={{ width: isMobile ? inputWidth : inputWidth }}
    >
      <>
        <input
          style={{
            border: errorMessage ? "1px solid #DC1818" : "",
            WebkitTextSecurity: !showPassword ? "square" : ""
          }}
          value={value}
          onChange={onChange}
          type={showPassword ? "text" : "password"}
          placeholder="Enter your password"
          className="passwordInput"
        />
        <button
          onClick={() => setShowPassword(!showPassword)}
          className="toggleButton"
          type="button"
        >
          <img
            src={isPasswordVisible ? showImage : hideImage}
            alt=""
            onClick={handlePasswordVisibility}
          />
        </button>
      </>
      {errorMessage && <p className="errorMessage">{errorMessage}</p>}
    </div>
  );
};

export default InputPassword;
